import {Injectable} from '@angular/core';
import {TokenService} from "../shared/service/token.service";
import {concatMap, tap} from "rxjs";
import {AgreeLicenseModalComponent, AgreeLicenseModalData} from "./agree-license-modal/agree-license-modal";
import {MatDialog} from "@angular/material/dialog";
import {LicenseService} from "./license.service";

const SupportedLicenseLocales = ['en', 'de', 'fr', 'nl'];
const DefaultLicenseLocale = 'en';

@Injectable()
export class LicenseAgreementService {

  constructor(
    private readonly token: TokenService,
    private readonly license: LicenseService,
    private readonly dialog: MatDialog,
  ) { }

  public get hasAgreedWithCurrentLicense() {
    return this.token.getLicenseAgreed();
  }

  public enforceLicenseAgreement() {
    if (! this.hasAgreedWithCurrentLicense) {
      this.confirmLicenseAgreement().subscribe();
    }
  }

  private get licenseLanguage(): string {
    const locale = this.token.getCulture();
    const language = locale?.substring(0, 2);
    return SupportedLicenseLocales.includes(language) ? language : DefaultLicenseLocale;
  }

  private confirmLicenseAgreement() {
    const data = {license$: this.license.licenseFor(this.licenseLanguage)} as AgreeLicenseModalData;
    const dialog = this.dialog.open(AgreeLicenseModalComponent, {disableClose: true, data});
    return dialog.componentInstance.confirmed.pipe(
      concatMap(() => this.license.agree(this.token.getLoginId())),
      tap(() => this.token.loadTokenFromCookies()),
    );
  }
}
